import type { FC } from 'react';
import { getMediaUrl } from 'utils/assets';
import { Translation } from 'utils/translations';

import styles from './EmptyState.module.scss';

export enum SignUpErrorType {
  ServerError = '500-error',
  NotFound = '404-error',
}

type SignUpEmptyStateProps = {
  type: SignUpErrorType | undefined;
};

const SignUpEmptyState: FC<SignUpEmptyStateProps> = ({ type = undefined }) => {
  if (!type) return null;

  return (
    <div className={styles['empty-state-container']}>
      {type === SignUpErrorType.NotFound && (
        <>
          <img
            width={200}
            height={200}
            src={getMediaUrl('/yellow/404.webp')}
            alt="Error Page Not Found"
          />
          <br />
          <p className={styles['error-empty-state-text']}>
            <Translation message="page_not_found" />
          </p>
        </>
      )}
      {type === SignUpErrorType.ServerError && (
        <>
          <img
            width={200}
            height={200}
            src={getMediaUrl('/yellow/500.webp')}
            alt="internal server error"
          />
          <br />
          <p className={styles['error-empty-state-text']}>
            500 – Internal Server Error
          </p>
        </>
      )}
    </div>
  );
};

export default SignUpEmptyState;
